import { FC, PropsWithChildren } from 'react';

import GridColumn from 'src/components/Grid/GridColumn';
import GridRow from 'src/components/Grid/GridRow';

import styles from 'src/components/Grid/grid.less';

const GridContainer: FC<PropsWithChildren> = ({ children }) => {
    return <div className={styles.gridContainer}>{children}</div>;
};

export default GridContainer;

export { GridRow, GridColumn };
